import * as React from 'react';
import * as TypeStyle from 'typestyle';
import { InvertTextColors, TextColors } from '../styles/Colors';
import { TabStyles } from '../styles/TabStyles';
import { EventUtilsOptOut } from '../utils/ReactHelpers';

export interface LabelProps {
  useDarkStyling?: boolean;
}

const { Default: FontSize } = TabStyles.Typography.Sizing;

const LabelStyleName = TypeStyle.style({
  color: TextColors.Secondary,
  fontSize: FontSize,
  height: `21px`,
  lineHeight: `21px`,
  $nest: {
    '&.dark': { color: InvertTextColors.Secondary },
  }
});

/** @private not intended for external use */
export const LabelWidget: React.FunctionComponent<LabelProps & React.LabelHTMLAttributes<HTMLLabelElement>> = props => {
  const { useDarkStyling, ...htmlAttrs } = props;

  const handleClick = React.useCallback<React.MouseEventHandler<HTMLLabelElement>>(e => {
    if (!e.currentTarget.htmlFor) { return; }

    const focusTarget = document.getElementById(e.currentTarget.htmlFor);
    if (focusTarget && !(focusTarget.tabIndex === null || focusTarget.tabIndex === undefined)) {
      focusTarget.focus();
    }
    props.onClick?.(e);
  }, [props.onClick]);

  return (
    <label
      {...htmlAttrs}
      {...EventUtilsOptOut}
      className={TypeStyle.classes(LabelStyleName, props.className, useDarkStyling && 'dark')}
      onClick={handleClick}
    />
  );
};
LabelWidget.displayName = 'LabelWidget';
